<template>
    <div class="offer-card" :class="{ 'own-message': isOwn }">
        <!-- {{ message.id }} -->
        <div class="offer-content">

            <div class="offer-details">
                <div class="d-flex gap-2">
                    <!-- Offer Price -->
                    <div class="offer-price" :class="priceClass">
                        {{ message.offer.price | currency(" DA", 0, { symbolOnLeft: false }) }}
                    </div>

                    <!-- Original Price -->
                    <div class="offer-price"
                        :class="message.offer.status === null || message.offer.status === 1 ? 'text-muted text-decoration-line-through' : ''">
                        {{ message.offer.old_price || originalPrice | currency(" DA", 0, { symbolOnLeft: false }) }}
                    </div>
                </div>

                <!-- Offer Actions -->
                <div v-if="showActions" class="offer-actions">
                    <button :disabled="loader" @click="handleRespond(true)" class="btn-offer btn-offer-accept">
                        <i class="mdi mdi-check"></i>
                        {{ $t("action.accept") }}
                    </button>
                    <button :disabled="loader" @click="handleRespond(false)" class="btn-offer btn-offer-refuse">
                        <i class="mdi mdi-close"></i>
                        {{ $t("action.refuse") }}
                    </button>
                </div>
                <!-- Accepted Offer -->
                <div v-else-if="message.offer.status === 1">
                    <div v-if="message.offer.user_id !== message.from_contact.id"
                        class="offer-status offer-status-accepted">
                        <i class="mdi mdi-check-circle"></i>
                        {{ $t('ecommerce.product.acceptedOffers') }}
                    </div>
                    <span v-if="message.offer?.order != null" class="offer-status offer-status-accepted mt-1">
                        <i class="mdi mdi-check-circle"></i> {{ $t("sentence.sold") }}
                    </span>
                    <router-link v-else-if="selectedContact.product.deleted_at === null && message.offer.user_id === user.id && message.type === 'REQUEST_OFFER'"
                        class="btn-offer btn-offer-checkout mt-1"
                        :to="{ name: 'checkoutOrder', params: { id: message.offer.id, type: 'offer' } }">
                        {{ $t("page.checkout") }}
                    </router-link>
                </div>

                <!-- Refused Offer -->
                <div v-else-if="message.offer.status === 0 && message.offer.user_id !== message.from_contact.id"
                    class="offer-status offer-status-refused">
                    <i class="mdi mdi-close-circle"></i>
                    {{ $t("ecommerce.product.refusedOffers") }}
                </div>
            </div>
        </div>

        <div class="message-time text-secondary" :class="{ 'text-right': isOwn }">{{ message.created_at | moment }}
        </div>
    </div>
</template>

<script>
import config from "@/config";

export default {
    name: "OfferCard",
    props: {
        originalPrice: {
            type: Number||String,
            required: true
        },
        message: {
            type: Object,
            required: true
        },
        isOwn: {
            type: Boolean,
            default: false
        },
        user: {
            type: Object,
            required: true
        },
        selectedContact: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            storageUrl: config.storageUrl,
            loader: false
        };
    },
    mounted(){
        
    }
    ,
    computed: {
        showActions() {
            return this.message.from!==this.user.id&&
                this.message.to!==this.message.offer.user_id&&
                this.message.offer.status===null&&
                this.selectedContact.product.has_been_sold!==1;
        },
        priceClass() {
            // Rejected
            if (this.message.offer.status===0) {
                return 'text-danger text-decoration-line-through';
            }
            // Accepted
            if (this.message.offer.status===1) {
                return 'text-success font-weight-bold';
            }
            // Pending (status === null)
            return 'text-primary font-weight-bold';
        }
    },
    methods: {
        handleRespond(response) {
            this.loader=true;
            // message.offer_id may be undefined depending on how the message object is shaped.
            // Prefer the nested offer.id if present, otherwise fall back to offer_id field.
            const offerId = this.message && this.message.offer && this.message.offer.id ? this.message.offer.id : this.message.offer_id;
            this.$emit('respond', {
                offerId,
                response
            });
        }
    }
};
</script>

<style scoped>
.offer-card {
    max-width: 480px;
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid var(--gray-200);
}

.offer-card.own-message {
    border: 1px solid var(--gray-300);
}

.offer-card-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: var(--primary-light);
    border-bottom: 1px solid var(--primary-light);
}

.offer-card.own-message .offer-card-header {
    background: var(--color-nz);
}

.offer-icon {
    width: 20px;
    height: 20px;
    color: var(--color-nz);
    stroke-width: 2;
}

.offer-card.own-message .offer-icon {
    color: white;
}

.offer-label {
    font-size: 14px;
    font-weight: 600;
    color: var(--color-nz);
}

.offer-card.own-message .offer-label {
    color: white;
}

.offer-content {
    padding: 16px;
    padding-bottom: 0px;
}

.offer-image-wrapper {
    margin-bottom: 12px;
}

.offer-image {
    width: 100%;
    max-height: 200px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
    transition: opacity 0.2s;
}

.offer-image:hover {
    opacity: 0.9;
}

.offer-details {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.offer-price {
    font-size: 18px;
    font-weight: 700;
}

.offer-text {
    margin: 0;
    font-size: 14px;
    color: var(--gray-500);
    line-height: 1.5;
}

.offer-actions {
    display: flex;
    gap: 8px;
    margin-top: 4px;
}

.offer-status {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
}


.message-time {
    padding: 8px 16px;
    font-size: 11px;
}
</style>